//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'broadcast'
let resource_name = 'broadcast'
let resource_name_plural = 'broadcast'

let state = {
  campaigns: []
}

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async send ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/flow`, params)
      if(res.status === 200 && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error enviando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error enviando ${resource_name}.`})
      console.error(e)
    }
  },
  async instant ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error enviando ${resource_name} instantaneo.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error enviando ${resource_name} instantaneo.`})
      console.error(e)
    }
  },
  async message ({ commit }, params) {
    try {
      let res = await Vue.request.post(`message`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error enviando mensaje.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error enviando mensaje.`})
      console.error(e)
    }
  },
  async cast ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/filteredCast`, params)
      console.log(res)
      if(res.status == 200 && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error enviando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error enviando ${resource_name}.`})
      console.error(e)
    }
  },
  async sendFromFile ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/sendFromFile`, params)
      if(res.status == 200 && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error enviando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error enviando ${resource_name}.`})
      console.error(e)
    }
  },
  async schedule ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/schedule`, params)
      if(res.status == 200 && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agendando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agendando ${resource_name}.`})
      console.error(e)
    }
  },
  async campaigns ({ commit }, params) {
    try {
      if(!params.refreshing) commit('setCampaigns', [])
      let res = await Vue.request.get(`account/${params.account_id}/campaigns`, {params: params.params || {}})
      if(res.data.success) {
        commit('setCampaigns', res.data.resource.map(el => {
          el.loading = false
          return el
        }))
        if(params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo campañas de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo campañas de ${resource_name}.`})
      console.error(e)
    }
  },
  async message_counts ({ commit }, params) {
    try {
      let res = await Vue.request.get(`/campaign/metrics`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo métricas de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo campañas de ${resource_name}.`})
      console.error(e)
    }
  },
  async campaign_report ({ commit }, params) {
    try {
      let res = await Vue.request.get(`campaign/${params.campaign_id}/report`)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo reporte de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo reporte de ${resource_name}.`})
      console.error(e)
    }
  },
  async cancel_campaign ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`campaign/${params.campaign_id}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeCampaign', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo reporte de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo reporte de ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`campaign/${params.campaign_id}`)
      if(res.data.success && params.callback) {
        commit('removeCampaign', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando campaña.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando campaña.`})
      console.error(e)
    }
  },
  async recovery ({ commit }, params) {
    try {
      let res = await Vue.request.get(`broadcast/${params.campaign_id}/recovery`)
      if(res.status === 200 && params.callback) {
        params.callback(res)
      } else if (params.callback) {
        params.callback({error: `Error recuperando campaña.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error recuperando campaña.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setCampaigns (state, items) {
    state.campaigns = items
  },
  removeCampaign (state, {campaign_id}) {
    let index = state.campaigns.findIndex(el => el._id === campaign_id)
    if (index >= 0) {
      state.campaigns.splice(index, 1)
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
